import slices from './slices';

export default {
  ...slices.postsSlice.actions,
  ...slices.commentsSlice.actions,
  ...slices.activeSlice.actions,
  ...slices.readReceiptsSlice.actions,
};
